import dev from '../../client_config/dev.json';
import type { CloudApisUrlKey } from './';

const apisRouteKeys = Object.keys(dev.apis) as CloudApisUrlKey[];

/**
 * Hosted-route API ids (`name` → same string), from `dev.apis` keys only.
 * Spread into `API_NAMES`; use `isCloudApisUrlKey` from `@/utils/api` for membership (single guard for URL resolution).
 */
export const CLOUD_API_NAME_IDENTITY = Object.fromEntries(
  apisRouteKeys.map(key => [key, key] as const)
) as { [K in CloudApisUrlKey]: K };
